import React from 'react';

import { Svg, Polygon, SvgProps } from 'react-native-svg';

const StepIcon: React.FC<SvgProps> = (props) => {
  const { width = '100%', height = '100%', color = '#ffffff' } = props;

  return (
    <Svg
      enable-background={'new 0 0 566.93 566.93'}
      viewBox={'0 0 566.93 566.93'}
      width={width}
      height={height}
    >
      <Polygon
        fill={color}
        points={
          '53.9,397.3 53.9,390.4 57.9,377.3 53.9,367.7 53.9,361.5 57.9,350.7 51,338.2 51,331.6 76.9,294.7 84.5,288.8 476.6,191.3 488.4,191.3 498.1,193.6 578.8,238.1 583.5,241.4 587.2,246.3 607,276.7 607,286.7 600.5,294.7 605.4,302.2 607,312.5 604.5,316.4 600.5,322 604.5,331.6 603.7,338.2 596.1,347.9 557.6,361.5 554.4,359.9 514,372.2 508.9,377.3 469.5,388.6 457.4,388.6 446.6,384.4 411.6,355.3 322.3,382.9 325.6,392.5 325.6,397.3 321.2,406.4 319.7,407.9 323.7,415.3 325.6,420.9 323.7,427.5 319.7,435.2 312.5,440 268.7,456.1 265.4,456.1 210.2,471.8 204.7,476 152,492.5 138.5,490.9 125.9,483.6'
        }
      />
    </Svg>
  );
};

export default StepIcon;
